var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('post',{attrs:{"item":_vm.post,"addComment":function (data) { return _vm.addPostComment(data); },"addLike":function (data) { return _vm.addPostLike(data); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }